import { Stack } from "@mui/material";
import {
  Children,
  cloneElement,
  isValidElement,
  ReactNode,
  type MouseEvent,
} from "react";

// ToggleChipGroup.tsx
// Kiro made this
interface ToggleChipGroupProps {
  value: string | number | (string | number)[];
  onChange: (_event: MouseEvent<HTMLDivElement>, _value: any) => void;
  exclusive?: boolean;
  children: ReactNode;
}

export default function ToggleChipGroup({
  value,
  onChange,
  exclusive = false,
  children,
}: ToggleChipGroupProps) {
  const handleChange = (
    event: MouseEvent<HTMLDivElement>,
    childValue: string | number,
  ) => {
    if (exclusive) {
      onChange(event, value === childValue ? "" : childValue);
      return;
    }
    const arr = Array.isArray(value) ? value : [];
    const next = arr.includes(childValue)
      ? arr.filter((v) => v !== childValue)
      : [...arr, childValue];
    onChange(event, next);
  };

  return (
    <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return child;
        const childValue = child.props.value;
        const selected = exclusive
          ? value === childValue
          : Array.isArray(value) && value.includes(childValue);
        return cloneElement(child, { selected, onChange: handleChange });
      })}
    </Stack>
  );
}
